import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("ParentEngagementPermissions")
export class ParentEngagementPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly Edit = 2;
    static readonly Delete = 4;
    static readonly SeeAll = 8;
    // 16 is skipped deliberately — see ParentEngagementPermissions.cs.
    // Early Dispute Resolution shares this category.
    static readonly Export = 32;
}